function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <a href="/" className="footer__logo">
            <span className="footer__logo-text">EbiTrade</span>
          </a>
          <p className="footer__tagline">
            Bitácora de trading.
          </p>
        </div>

        <div className="footer__columns">
          <div className="footer__col">
            <h3>Producto</h3>
            <a href="/#bitacora">Bitácora</a>
            <a href="/#analitica">Analítica</a>
            <a href="/#comunidad">Comunidad</a>
            <a href="/#precios">Precios</a>
          </div>
          <div className="footer__col">
            <h3>Recursos</h3>
            <a href="#docs">Documentación</a>
            <a href="#blog">Blog</a>
            <a href="#api">API</a>
          </div>
          <div className="footer__col">
            <h3>Legal</h3>
            <a href="/privacidad/">Política de Privacidad</a>
            <a href="/terminos/">Términos y Condiciones</a>
            <a href="/privacidad/#seguridad">Seguridad</a>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <p>© {year} EbiTrade · ebitrade.com</p>
        <p className="footer__disclaimer">
          EbiTrade no ofrece asesoría financiera. El trading conlleva riesgo de pérdida de
          capital.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
